import React from "react";
import * as styles from "./BulkUpdate.module.scss";

import SimpleField from "./FieldTypes/SimpleField";
import StatusField from "./FieldTypes/StatusField";
import MultilineField from "./FieldTypes/MultilineField";

const Components = {
  simple: SimpleField,
  status: StatusField,
  multiline: MultilineField,
};

export default class FieldUpdate extends React.Component {
  state = {
    value: "",
    policy: this.props.fieldInfo.defaultPolicy || "replace", // completely replace, replace only empty
    confirmText: "",
    loading: false,
  };

  handleChangeValue = (update) => {
    const { value } = update;
    this.setState({ value });
  };

  handleChangePolicy = (e) => {
    this.setState({ policy: e.target.value });
  };

  handleSubmit = () => {
    const { value, policy } = this.state;
    const { items, fieldInfo } = this.props;
    const { label } = fieldInfo;
    const firstPart = `Please confirm that you would like to update ${
      items.length
    } work${items.length === 1 ? "" : "s"} by`;
    const displayVal = value.replace(/<(?!br).*?>/g, "");
    const messages = {
      replace: `${firstPart} replacing the ${label} field with the following text:<br><br>${displayVal}`,
      emptyOnly: `${firstPart} replacing only the empty ${label} fields with the following text:<br><br>${displayVal}`,
      above: `${firstPart} adding the following text on a line ABOVE the existing text of each ${label} field:<br><br>${displayVal}`,
      below: `${firstPart} adding the following text on a line BELOW the existing text of each ${label} field:<br><br>${displayVal}`,
    };
    const confirmText = value
      ? messages[policy]
      : "You have left the text blank. This could result in deleting the contents of this field for the selected works. Proceed?";

    this.setState({ confirmText });
  };

  handleCancel = () => {
    this.setState({ confirmText: "" });
  };

  handleUpdateRecords = () => {
    const { value, policy } = this.state;
    const { items, fieldInfo } = this.props;

    const data = {
      items,
      fieldName: fieldInfo.name,
      value,
      policy,
    };

    $.ajax("/bulk_update", {
      method: "POST",
      data,
      success: (response) => {
        window.location = "/bulk_update_complete";
      },
      error: (response, x, y) => {
        alert(
          "An error has occurred. Please try again or contact support if the issue persists."
        );
        location.reload();
      },
    });

    this.setState({ loading: true, confirmText: "" });
  };

  render() {
    const { fieldInfo, onClickBack } = this.props;
    const { value, policy, confirmText, loading } = this.state;
    const FieldComponent = Components[fieldInfo.fieldType];

    if (confirmText) {
      return (
        <div>
          <h1 className={styles.h1}>Confirm</h1>
          <p
            className={styles.confirm}
            dangerouslySetInnerHTML={{ __html: confirmText }}
          />
          <button onClick={this.handleCancel} className={styles.button}>
            CANCEL
          </button>
          <button onClick={this.handleUpdateRecords} className={styles.button}>
            CONFIRM
          </button>
        </div>
      );
    }

    if (loading) {
      return (
        <div>
          <h1>Updating Records...</h1>
          <div className={styles.loading} />
        </div>
      );
    }

    return (
      <div>
        <h1 className={styles.h1}>{`Update ${fieldInfo.label}`}</h1>

        <FieldComponent
          value={value}
          policy={policy}
          fieldInfo={fieldInfo}
          onChangeValue={this.handleChangeValue}
          onChangePolicy={this.handleChangePolicy}
        />

        <button onClick={onClickBack} className={styles.button}>
          BACK
        </button>
        <button onClick={this.handleSubmit} className={styles.button}>
          NEXT
        </button>
      </div>
    );
  }
}
